/** @see app/common/enums/catalog/ProductTypeEnum */
export const ProductTypeEnum = {
    card: 1,
    realModifier: 2,
    virtualModifier: 3,
};